<script>
import BottomNavigationWorker from "@/components/assetComponents/BottomNavigationWorker.vue";
import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import $ from "jquery";

export default {
  name: "W_MyCustomer",
  components: {LoadingPage, BottomNavigationWorker},
  setup() {

    let loading = ref(false)
    let dialog = ref(false)

    let my_customer = ref([])
    let all_customer = ref([])

    let input_search = ref()

    let data = ref({
      action: 'add',
      name: '',
      car: '',
    })

    watch(() => input_search.value, () => {
      my_customer.value = []
      all_customer.value.filter((item) => {
        if (item.name.includes(input_search.value)) my_customer.value.push(item)
      })
    })

    function get_customer() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'show'}, 'worker/customers', true).then((res) => {
        loading.value = false
        my_customer.value = res.data
        all_customer.value = res.data
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_customer)
      })
    }
    get_customer()

    function open_dialog() {
      let div_dialog = $('#dialog')

      if (dialog.value) {
        div_dialog.removeClass('animate__fadeIn').addClass('animate__fadeOut')
        setTimeout(() => {
          dialog.value = false
          data.value = {
            action: 'add',
            name: '',
            car: '',
          }
        }, 700)
      } else {
        div_dialog.removeClass('animate__fadeOut').addClass('animate__fadeIn')
        dialog.value = true
      }
    }

    function add_new_customer() {
      if (data.value.name.trim().length < 1) {
        Swals.Warning('لطفا نام و نام خانوادگی مشتری را وارد کنید!');
        return false
      }
      if (data.value.car.trim().length < 1) {
        Swals.Warning('لطفا مدل وسیله نقلیه مشتری را وارد کنید!');
        return false
      }

      loading.value = true
      FreeWorld.Heisenberg(data.value, 'worker/customers', true).then((res) => {
        loading.value = true
        if (res.data.status === 'ok') {
          Swals.Done('مشتری شما با موفقیت ثبت شد')
          get_customer()
          open_dialog()
        } else {
          Swals.Fault('متاسفانه مشتری شما ثبت نشد!')
        }
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, add_new_customer)
      })
    }


    let scroll = false
    onMounted(() => {
      scroll = true
    })
    onBeforeUnmount(() => {
      scroll = false
    })
    $(document).ready(() => {
      if (scroll) {
        $("#chile-main").on('scroll', () => {
          const scrollPosition = $("#chile-main").scrollTop();
          // اگر کاربر به پایین اسکرول کرده باشد، کلاس hidden اضافه شود، در غیر این صورت حذف شود

          scrollPosition > 150 ? $("#add_icon").removeClass('animate__fadeInUpBig').addClass('animate__fadeOutDownBig') : $("#add_icon").removeClass('animate__fadeOutDownBig').addClass('animate__fadeInUpBig')

        });
      }
    });

    return {
      loading,
      my_customer,
      input_search,
      dialog,
      data,
      open_dialog,
      add_new_customer,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div v-if="dialog" @click="open_dialog" class="bg_dialog"></div>
  <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog px-3">
    <div class="rounded-4 bg-white p-3">
      <div class="position-relative">
        <p class="font-4 text-color font-bold text-center">ثبت مشتری جدید</p>
        <img @click="open_dialog" class="icon-size-4 position-absolute top-0 start-0"
             src="../assets/img/icon-closeBgColor.svg" alt="">
      </div>

      <hr>

      <p class="font-4 text-color font-bold mb-2">نام و نام خانوادگی مشتری</p>
      <input v-model="data.name" class="p-3 w-100 bg-custom rounded-pill shadow-custom mb-4 text-center" type="text">

      <p class="font-4 text-color font-bold mb-2">نام خودرو</p>
      <input v-model="data.car" class="p-3 w-100 bg-custom rounded-pill shadow-custom mb-5 text-center" type="text">

      <div class="d-flex justify-content-center">
        <p @click="add_new_customer"
           class="font-4 font-bold text-center rounded-pill bg-color-liner text-white p-3 w-35">ثبت</p>
      </div>
    </div>
  </div>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">مشتری های من</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div style="top: -1rem"
           class="d-flex align-items-center justify-content-between rounded-pill p-2 shadow-custom position-sticky bg-white">
        <img src="../assets/img/icon-search.svg" class="icon-size-3 mx-2">
        <input v-model="input_search" type="text" placeholder="جستجو نام مشتری" class="w-85 p-2">
      </div>

      <div v-if="my_customer.length === 0"
           class="animate__animated animate__fadeIn w-100 h-75 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>

      <div v-else v-for="item in my_customer" :key="item.id" class="animate__animated animate__fadeIn d-flex align-items-center justify-content-between p-3 shadow-KhA mt-4 rounded-5">
        <div class="overflow-hidden">
          <p class="text-color font-bold font-5" :class="item.name.length > 15 ? 'txtoverflow':''">{{ item.name }}</p>
        </div>

        <div class="overflow-hidden">
          <p class="font-6" :class="item.car.length > 18 ? 'txtoverflow':''">{{ item.car }}</p>
        </div>

        <router-link :to="{name:'W_ServicesPerformed' , params:{service_id:item.id}}" class="bg-green text-decoration-none px-3 py-2 font-6 rounded-pill text-white">مشاهده سرویس ها</router-link>
      </div>

      <div @click="open_dialog" id="add_icon"
           class="animate__animated animate__fadeInUpBig position-fixed d-flex flex-column align-items-center text-decoration-none max_width bottom-15">
        <img class="icon-size-7 icon_shadow mb-2" src="../assets/img/icon-add.svg" alt="">
        <p class="font-5 text-decoration-none text-color text-center font-bold">ثبت مشتری جدید</p>
      </div>


      <BottomNavigationWorker></BottomNavigationWorker>

    </div>
  </div>

</template>

<style scoped>
.shadow-KhA {
  box-shadow: 0px 8px 18px rgba(189, 215, 234, 0.6);
}
</style>